<div class="error-container">
  <div class="imagen">
    <img src="../../../assets/undraw_warning_re_eoyh.svg"/>
  </div>
  <h1>¡Ups! Algo salió mal</h1>
  <p>{{msgError}}</p>
  <p>Le recomendamos comunicarse con su asesor comercial para obtener asistencia.</p>
</div>